import qcrema from './Delice/qcrema.png';
import qfresco from './Delice/qfresco.png';
import qmozarella from './Delice/qmozarella.png';
import Mantequilla from './Delice/mantequilla.png';
import madurados from './Delice/qmadurados.png';
import qgourmet from './Delice/qgourmet.png';
import dips from './Delice/dips.png';

//CATEGORIA
import dmozarella from './Delichizz/dmozarella.png';
import dEdam from './Delichizz/dEdam.png';
import dcrema from './Delichizz/dcrema.png';
import ucrema from './Untadeli/ucrema.png';
import uuntable from './Untadeli/uuntable.png';
import fmadurados from './Frico/fmadurados.png';

//DETALLE DELICE
import img1 from './Delice/qcrema/img1.png';
import img2 from './Delice/qcrema/img2.png';
import img3 from './Delice/qcrema/img3.png';
import img4 from './Delice/qcrema/img4.png';
import img5 from './Delice/qcrema/img5.png';
import img6 from './Delice/qcrema/img6.png';
import img7 from './Delice/qcrema/img7.png';
import img8 from './Delice/qcrema/img8.png';
import img9 from './Delice/qcrema/img9.png';
import img10 from './Delice/qcrema/img10.png';
import img11 from './Delice/img11.png';
import img12 from './Delice/img12.png';
import img13 from './Delice/img13.png';
import img14 from './Delice/img14.png';

import img15 from './Delice/qmozzarella/img1.png';
import img16 from './Delice/qmozzarella/img2.png';
import img17 from './Delice/qmozzarella/img3.png';
import img18 from './Delice/qmozzarella/img4.png';
import img19 from './Delice/qmozzarella/img5.png';
import img20 from './Delice/qmozzarella/img6.png';

import img21 from './Delice/qmantequilla/img1.png';
import img22 from './Delice/qmantequilla/img2.png';
import img23 from './Delice/qmantequilla/img3.png';

import img24 from './Delice/qmadurados/img1.png';
import img25 from './Delice/qmadurados/img2.png';
import img26 from './Delice/qmadurados/img3.png';
import img27 from './Delice/qmadurados/img4.png';
import img28 from './Delice/qmadurados/img5.png';
import img29 from './Delice/qmadurados/img6.png';
import img30 from './Delice/qmadurados/img7.png';
import img31 from './Delice/qmadurados/img8.png';

import img32 from './Delice/qgourmet/img1.png';
import img33 from './Delice/qgourmet/img2.png';
import img34 from './Delice/qgourmet/img3.png';
import img35 from './Delice/qgourmet/img4.png';
import img36 from './Delice/qgourmet/img5.png';
import img37 from './Delice/qgourmet/img6.png';
import img38 from './Delice/qgourmet/img7.png';
import img39 from './Delice/qgourmet/img8.png';

import img40 from './Delice/Dips/img1.png';
import img41 from './Delice/Dips/img2.png';
import img42 from './Delice/Dips/img3.png';
import img43 from './Delice/Dips/img4.png';

//DELICHIZZ
import img44 from './Delichizz/dmozzarella/img1.png';
import img45 from './Delichizz/dmozzarella/img2.png';
import img46 from './Delichizz/dmozzarella/img3.png';
import img47 from './Delichizz/dmozzarella/img4.png';

import img48 from './Delichizz/dedam/img1.png';
import img49 from './Delichizz/dedam/img2.png';
import img50 from './Delichizz/dedam/img3.png';
import img51 from './Delichizz/dedam/img4.png';

//UNTADELI
import img52 from './Untadeli/ucrema/img1.png'
import img53 from './Untadeli/ucrema/img2.png'
import img54 from './Untadeli/ucrema/img3.png'
import img55 from './Untadeli/ucrema/img4.png'

import img56 from './Untadeli/uuntable/img1.png'
import img57 from './Untadeli/uuntable/img2.png'
import img58 from './Untadeli/uuntable/img3.png'
import img59 from './Untadeli/uuntable/img4.png'

//FRICO 
import img60 from './Frico/frmadurados/img1.png'
import img61 from './Frico/frmadurados/img2.png'
import img62 from './Frico/frmadurados/img3.png'
import img63 from './Frico/frmadurados/img4.png'
import img64 from './Delice/lcondensada.png';
// import img65 from './Untadeli/frmadurados/img1.png'
// import img66 from './Untadeli/frmadurados/img1.png'
// import img67 from './Untadeli/f/rmadurados/img1.png'



// categoria de roducto
export const imagesDelice = {
    qcrema,
    qfresco,
    qmozarella,
    Mantequilla,
    madurados,
    qgourmet,
    dips
  };

  export const imagesDelichizz = {
    dmozarella,
    dEdam,
    dcrema,
  };

  export const imagesUntadeli = {
    ucrema,
    uuntable
  };

  export const imagesFrico = {
    fmadurados
  };

  //detalle de producto DELICE
  export const deliceQuesoCrema = {
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img64
  };

  export const deliceQuesoFresco = {
    img11,
    img12,
    img13,
    img14,
  };

  export const deliceQuesoMozzarella = {
    img15,
    img16,
    img17,
    img18,
    img19,
    img20
  };
  export const deliceMantequilla = {
    img21,
    img22,
    img23,
  };

  export const deliceQuesoMadurados = {
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
  };

  export const deliceQuesoGourmet = {
    img32,
    img33,
    img34,
    img35,
    img36,
    img37,
    img38,
    img39,
  };

  export const deliceDips = {
    img40,
    img41,
    img42,
    img43,
  };

  //detalle de producto DELICHIZZ
  export const delichizzMozzarella = {
    img44,
    img45,
    img46,
    img47,
  };

  export const delichizzEdam = {
    img48,
    img49,
    img50,
    img51
  };

  //detalle de producto UNTADELI
  export const untadeliCrema = {
    img52,
    img53,
    img54,
    img55
  };
  export const untadeliUntable = {
    img56,
    img57,
    img58,
    img59
  };

  //detalle de producto UNTADELI
  export const fricoMadurados = {
    img60,
    img61,
    img62,
    img63,
  };
